import React, { useEffect, useState } from "react";
import { UiComponents } from "@simulanisindia/ui";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { GET_GROUP_LIST } from "../../apiClient/apiEndpoints";
import OrgCards from "../../components/OrgCards";
import { CHANNEL_GROUP_LIMIT } from "../../Constant/constant";
import GroupCardSkeleton from "../../Skeleton/GroupCardSkeleton";
import { Groups, OrgManageIcon } from "../../Assets/Icons";

const { GridView, NormalGradientButton } = UiComponents;

const OrganizationList = ({ search, handleUpdateLength }) => {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [querySearch, setQuerySearch] = useState();
  const [hasMore, setHasMore] = useState(true);
  const [paginationPage, setPaginationPage] = useState(1);

  const getAllOrganization = async (pageId, searchQuery = null) => {
    try {
      let pageNumber = pageId || paginationPage;
      let data = await apiClient.get(`${SSO_URL}${GET_GROUP_LIST}`, {
        params: {
          limit: CHANNEL_GROUP_LIMIT,
          page: pageNumber,
          search: searchQuery || null,
        },
      });

      setList((pre) => (pageNumber == 1 ? [...data] : [...pre, ...data]));
      setHasMore(data.length === CHANNEL_GROUP_LIMIT);
      setPaginationPage(data.length === CHANNEL_GROUP_LIMIT ? Number(pageNumber) + 1 : 1);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    if(handleUpdateLength) handleUpdateLength(list.length);
  },[list])

  useEffect(() => {
    const handler = setTimeout(() => {
      setQuerySearch(search);
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [search]);

  useEffect(() => {
    setLoading(true);
    getAllOrganization(1, querySearch);
  }, [querySearch]);

  const handleClickManage = (id) => {
    navigate(`/organization/manage/subscription/${id}`);
  };

  const loadMoreData = () => {
    getAllOrganization(paginationPage, querySearch);
  };

  return (
    <>
      <div id="scrollableDivGroups" style={{ height: "100%", overflow: "auto" }} className="scrollable-container">
          {(!loading && list.length === 0) ? 
            <div className="noOrgContent">
            <h6>No organizations found</h6>
             <p>
             You haven’t added any organizations yet. Click{" "}
             <NormalGradientButton icon={<Groups />} text="Create Organization" onClick={() => navigate('/organization/create')} /> to get started.
             </p>
            </div>
            :
          <InfiniteScroll
            scrollThreshold={0.7}
            dataLength={list.length}
            next={loadMoreData}
            hasMore={hasMore}
            loader={ <div className="mt-3"> <GroupCardSkeleton length= {3} /> </div> }
            scrollableTarget="scrollableDivGroups"
          >
                {list.length > 0 &&
                    <GridView>
                      {list.map((item, index) => (
                        <OrgCards
                          orgImage={item.avatar || null}
                          orgName={item.name}
                          id={item.uuid}
                          orgParent=""
                          showAppCount={true}
                          appCount={item.count.applications}
                          showResourceCount={true}
                          resourceCount={item.count.resources}
                          showAmount={true}
                          amount={item.count.amount}
                          manage={true}
                          handleClickManage={handleClickManage}
                        />
                      ))}
                    </GridView>
             }
          </InfiniteScroll>
           }


      </div>
    </>
  );
};

export default OrganizationList;